var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53826 13.3651C3.90674 13.8354 3.5 14.5729 3.5 15.402V19.428C3.5 20.8485 4.6939 22 6.16667 22H17.8333C19.3061 22 20.5 20.8485 20.5 19.428V12.072C20.5 11.0689 19.9046 10.1999 19.0361 9.77588M4.53826 13.3651C4.98871 13.0296 5.55352 12.83 6.16667 12.83H10.6505C11.2577 12.83 11.832 12.5541 12.2116 12.0801L13.6773 10.2498C14.0569 9.77587 14.6312 9.5 15.2384 9.5H17.8333C18.2661 9.5 18.6748 9.59942 19.0361 9.77588M4.53826 13.3651V5C4.53826 3.34315 5.8814 2 7.53826 2H16.0361C17.693 2 19.0361 3.34315 19.0361 5V9.77588M7.53826 8.5H9.65047C10.755 8.5 11.6505 7.60457 11.6505 6.5V6.5C11.6505 5.39543 10.755 4.5 9.65047 4.5H9.59436C8.45881 4.5 7.53826 5.42055 7.53826 6.55611V8.5ZM7.53826 8.5V10.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressKit);
export default __webpack_public_path__ + "static/media/press_kit.89adab121a7394886db68b4e6deb8a0a.svg";
export { ForwardRef as ReactComponent };